import { clearError } from '../../Redux/features/errors/errorsSlice';

const onQueryStarted = async (arg, {
  dispatch,
}) => {
  dispatch(clearError());
};

export default onQueryStarted;
